// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"path","attrs":{"fill":"props.filledColor","d":"M7.00008 6C7.00008 3.23858 9.23865 1 12.0001 1C14.7615 1 17.0001 3.23858 17.0001 6C17.0001 8.41896 15.2823 10.4367 13.0001 10.9V17H11.0001V10.9C8.71784 10.4367 7.00008 8.41896 7.00008 6ZM3.10503 11H8.00008V13H4.89512L4.11734 20H19.8828L19.105 13H16.0001V11H20.8951L22.1173 22H1.88281L3.10503 11Z"}}]};

const Location1FilledIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'location-1-filled',
    ref,
    icon: element,
  },
));

Location1FilledIcon.displayName = 'Location1FilledIcon';

export default Location1FilledIcon;
